"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _clsx = _interopRequireDefault(require("clsx"));

var _styles = require("@material-ui/core/styles");

var _pickReactKnownProp = require("pick-react-known-prop");

var _Typography = _interopRequireDefault(require("@material-ui/core/Typography"));

var _useTranslate = _interopRequireDefault(require("@sprinx/react-globalize/useTranslate"));

var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    root: {
      paddingTop: theme.spacing(2),
      paddingBottom: theme.spacing(2)
    },
    text: (0, _defineProperty2.default)({
      fontWeight: 300,
      fontSize: 14
    }, theme.breakpoints.up('md'), {
      fontSize: 16
    })
  };
}, {
  name: 'ProductDetailNote'
});

function ProductDetailNote(_ref) {
  var pClasses = _ref.classes,
      className = _ref.className,
      product = _ref.product,
      rest = (0, _objectWithoutProperties2.default)(_ref, ["classes", "className", "product"]);
  var classes = useStyles({
    classes: pClasses
  });
  var t = (0, _useTranslate.default)();
  var productNote = product.extra.additionalNote;
  var nextProductNote = productNote.length > 150 ? "".concat(t(productNote).slice(0, 150), "...") : t(productNote);

  if (productNote.length > 0) {
    return /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({}, (0, _pickReactKnownProp.pickHTMLProps)(rest), {
      className: (0, _clsx.default)(classes.root, className)
    }), /*#__PURE__*/_react.default.createElement(_Typography.default, {
      className: classes.text
    }, nextProductNote));
  }

  return null;
}

process.env.NODE_ENV !== "production" ? ProductDetailNote.propTypes = {
  classes: _propTypes.default.shape({
    root: _propTypes.default.string,
    text: _propTypes.default.string
  }),
  className: _propTypes.default.string,
  product: _propTypes.default.shape({
    extra: _propTypes.default.shape({
      additionalNote: _propTypes.default.arrayOf(_propTypes.default.shape({
        language: _propTypes.default.string,
        text: _propTypes.default.string
      }))
    }).isRequired
  }).isRequired
} : void 0;
ProductDetailNote.defaultProps = {
  classes: undefined,
  className: undefined
};
var _default = ProductDetailNote;
exports.default = _default;